import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIdPath = returnPath("/templates/packages/:id");
export const getIndexPath = returnPath("/templates/packages");
export const getCreatePath = returnPath("/templates/packages/create");
